import { CommonModule,CurrencyPipe,DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy,Component,DEFAULT_CURRENCY_CODE,ElementRef,HostListener,Inject,OnDestroy,ViewChild } from '@angular/core';
import { FormControl,ReactiveFormsModule,UntypedFormControl } from '@angular/forms';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import {
MatLegacyDialog as MatDialog,
MatLegacyDialogConfig as MatDialogConfig,
MatLegacyDialogModule as MatDialogModule,
MatLegacyDialogRef as MatDialogRef,
MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA
} from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Store } from '@ngrx/store';
import { BehaviorSubject,combineLatest,firstValueFrom,Observable,Subject,Subscription } from 'rxjs';
import { filter,map,withLatestFrom } from 'rxjs/operators';
import { SimplebarAngularModule } from 'simplebar-angular';
import { AccountsReceivableLedgerTemplateEntity } from '../../../dave-data-module/entities/accounts-receivable-ledger-template.entity';
import { AccountsReceivableLedgerEntity,AccountsReceivableLedgerTypeEnum } from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { QuantityTypeNames } from '../../../dave-data-module/entities/quantity-type.entity';
import {
AccountsReceivableLedgerPostType
} from '../../../dave-data-module/graphql-types';
import { ARLTemplateTypeResolver } from '../../../dave-data-module/guards/a-r-l-template-type.resolver';
import { FrontendDate } from '../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { ArlDataService } from '../../../dave-data-module/services/arl-data.service';
import { ArlTemplateDataService } from '../../../dave-data-module/services/arl-template-data.service';
import { MaterialDataService } from '../../../dave-data-module/services/material-data.service';
import { PaginatedMaterialService } from '../../../dave-data-module/services/paginated-material.service';
import { State } from '../../../dave-data-module/State';
import { getAccountsReceivableLedgerTemplateDictionary,getARLTemplateTypes,getARLTemplateTypesFetched,getQuantityTypes } from '../../../dave-data-module/State/selectors/accounting.selector';
import { getCommissionTypes } from '../../../dave-data-module/State/selectors/commissionType.selectors';
import { getLedgerImportDictionary,getLedgerImports } from '../../../dave-data-module/State/selectors/ledger-import.selector';
import { DaveDoubleIconModule } from '../../../dave-double-icon/dave-double-icon.module';
import { DaveLoadingModule } from '../../../dave-loading/dave-loading.module';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { AppDialogService } from '../../../dave-utils-module/app-dialog-module/app-dialog.service';
import { PermissionService } from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import { SelectSearchOption } from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { SelectSearchModule } from '../../../dave-utils-module/select-search/select-search.module';
import {
appMatDialogDefaultConfig,
DEFAULT_TAX,
isNotNullOrUndefined
} from '../../../helper/helper';
import { LoadingService } from '../../../services/loading.service';
import { getCostFromArlTemplate } from '../arl-calculation/arl-calculation.helper';
import { ArlTemplateTableComponent } from '../arl-calculation/arl-template-table/arl-template-table.component';
import { NewOptionDefaultValues } from '../modify-booking-option/modify-booking-option.component';
import { ArlOutput } from '../select-arl-dialog/select-arl-dialog.component';
import { SelectArlDialogService } from '../select-arl-dialog/select-arl-dialog.service';
import {
    SelectLedgerImportLargeDialogComponent,
    SelectLedgerImportLargeDialogDialogData, SelectLedgerImportLargeDialogDialogReturnData,
} from '../select-ledger-import-large-dialog/select-ledger-import-large-dialog.component';
import { Dictionary } from '@ngrx/entity';
import { FilterTypes } from '../../../services/default-filter.service';
import {
    DuplicatePositionsDialogComponent,
    DuplicatePositionsDialogData,
    DuplicatePositionsDialogResult, ItemNumberInformation,
} from '../duplicate-positions-dialog/duplicate-positions-dialog.component';
import {
    ModifyBookingOptionTemplateDialogComponent, ModifyBookingOptionTemplateDialogComponentData,
} from '../modify-booking-option-template/modify-booking-option-template-dialog.component';
import {
    ModifyBookingOptionDialogComponentData
} from '../modify-booking-option/modify-booking-option-dialog/modify-booking-option-dialog.component';



enum templateTypes {
    none = 'none',
    all = 'all',
    commissionType = 'commissionType',
    arlTemplateType = 'arlTemplateType',
}
export type NewBookingOptionComponentReturnType =
    AccountsReceivableLedgerEntity[]
    | undefined
    | number[]
    | { arls: AccountsReceivableLedgerEntity[]; openSortDialog: boolean; openSortDialogDefaultItemNumber: string | null };

export interface NewOptionDialogData {
    newOptionDefaultValues?: NewOptionDefaultValues;
    addToLedgerImport?: boolean;
    accountsReceivableLedgerTemplateFilter?: {
        CommissionTypeId?: number;
    };
    ListView?: boolean;
    addedTemplateIds?: number[];
    onlyOne?: boolean;
    onlyReturnTemplateIds?: boolean;
    filterMaterialsByCustomerId?: number | null;
    isOrder?: boolean;
    isOffer?: boolean;
    selectLedgerImportDefaultFilter?: SelectLedgerImportLargeDialogDialogData['defaultFilter'];
    ledgerImportCurrentItemNumber?: ItemNumberInformation[]
}
interface TableData {
    BookingText: string;
    TemplateType?: string;
    Information: string;
    SumNetto: string;
    Quantity: string;
    QuantityType: string;
    Hint?: string;
    ARLTemplate: AccountsReceivableLedgerTemplateEntity;
    dontEditHint?: string;
}
@Component({
    selector: 'app-new-booking-option',
    templateUrl: './new-booking-option.component.html',
    styleUrls: ['./new-booking-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [DecimalPipe, CurrencyPipe, PaginatedMaterialService],
    standalone: true,
    imports: [
        CommonModule,
        MatCardModule,
        FontAwesomeModule,
        SelectSearchModule,
        MatInputModule,
        ReactiveFormsModule,
        MatTooltipModule,
        AppButtonModule,
        DaveLoadingModule,
        MatSelectModule,
        SimplebarAngularModule,
        MatTableModule,
        MatCheckboxModule,
        ArlTemplateTableComponent,
        MatDialogModule,
        DaveDoubleIconModule,
    ],
})
export class NewBookingOptionComponent implements OnDestroy {
    public static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        panelClass: [/*'custom-dialog-class-without-padding',*/ ...appMatDialogDefaultConfig.panelClass],
        maxWidth: '100%',
        width: '90%',
    };
    protected IsSmallWidth$ = new BehaviorSubject(false);
    @ViewChild('wrapperElement') private wrapperElement: ElementRef;

    @ViewChild(ArlTemplateTableComponent) ArlTemplateTableComponent: ArlTemplateTableComponent;

    @HostListener('window:resize')
    ngAfterViewChecked() {
        if (this.wrapperElement?.nativeElement) {
            const smallWidth = this.wrapperElement.nativeElement.offsetWidth < 640;
            if (this.IsSmallWidth$.value !== smallWidth) {
                this.IsSmallWidth$.next(smallWidth);
            }
        }
    }
    protected templateFilterTypes = templateTypes;

    public Multiselect = new BehaviorSubject(true);
    public EditMode = new BehaviorSubject(false);

    public ArlTypeForm = new FormControl<SelectSearchOption<{ id: number; type: templateTypes }>>({ id: null, type: templateTypes.all, optionLabel: 'Alle' });
    public SearchForm = new UntypedFormControl('');
    // public BookingPositionTemplates$: Observable<ReadonlyArray<TableData>> = combineLatest([
    //     this.store.select(getAccountsReceivableLedgerTemplates).pipe(filter(isNotNullOrUndefined)),
    //     this.ArlTypeForm.valueChanges.pipe(distinctUntilChanged()),
    //     this.SearchForm.valueChanges.pipe(startWith('')),
    // ]).pipe(
    //     map(([val, arlTypeForm, search]) =>
    //         val.filter(
    //             (v) =>
    //                 (arlTypeForm.type === templateTypes.all ||
    //                     (arlTypeForm.type === templateTypes.none && !v.CommissionTypeId && !v.ARLTemplateTypeId) ||
    //                     (arlTypeForm.type === templateTypes.commissionType && arlTypeForm.id === v.CommissionTypeId) ||
    //                     (arlTypeForm.type === templateTypes.arlTemplateType && arlTypeForm.id === v.ARLTemplateTypeId)) &&
    //                 !v.CustomProperties?.jveg &&
    //                 (!search || stringSearch(v.Information || '', search) || stringSearch(v.BookingText || '', search)),
    //         ),
    //     ),
    //     map((val) =>
    //         val.sort((a, b) => {
    //             const nameA = (a.BookingText || '').toUpperCase(); // Groß-/Kleinschreibung ignorieren
    //             const nameB = (b.BookingText || '').toUpperCase();
    //             if (nameA < nameB) {
    //                 return -1;
    //             }
    //             if (nameA > nameB) {
    //                 return 1;
    //             }
    //             return 0;
    //         }),
    //     ),
    //     withLatestFrom(this.store.select(getQuantityTypes), getFetched$(this.store, getARLTemplateTypesFetched, getARLTemplateTypes), this.store.select(getCommissionTypes)),
    //     map(([val, qt, type, commissiontype]) =>
    //         val.map((v) => ({
    //             ...v,
    //             SumNetto: this.currencyPipe.transform(NettoCost(v.Quantity, v.BaseCost), v.CurrencyCode),
    //             Quantity: this.decimalPipe.transform(v.Quantity),
    //             QuantityType: qt?.find((q) => q.Id === v.QuantityTypeId)?.Name || '',
    //             Hint: v.CustomProperties?.hint,
    //             dontEditHint: v.CustomProperties?.timeTrackingTemplate
    //                 ? 'Diese Vorlage ist für die automatische Zeiterfassung.'
    //                 : v.CommissionTypeId
    //                 ? 'Diese Vorlage gehört zu einer Auftragsart.'
    //                 : v.EventTypeId
    //                 ? 'Diese Vorlage gehört zu einer Ereignisart.'
    //                 : null,
    //             TemplateType: v.ARLTemplateTypeId ? type.find((arl) => arl.Id === v.ARLTemplateTypeId)?.Name : v.CommissionTypeId ? commissiontype.find((c) => c.Id === v.CommissionTypeId)?.Name : 'Kein Typ angegeben',
    //             ARLTemplate: v,
    //         })),
    //     ),
    //     shareReplay({ refCount: true, bufferSize: 1 }),
    // );
    public SelectedRowIndex: number;
    public SelectedTemplateId$ = new BehaviorSubject<number>(null);
    // private templateId: number = null;
    public Save$: Subject<void> = new Subject<void>();
    public MultipleSave$: Subject<void> = new Subject<void>();
    private subs: Subscription[] = [];
    public SelectedTemplates: number[] = [];
    public ShowSearchBar$ = new BehaviorSubject(false);
    public TemplateTypes$: Observable<Array<SelectSearchOption<{ id: number; type: templateTypes }>>> = combineLatest([getFetched$(this.store, getARLTemplateTypesFetched, getARLTemplateTypes), this.store.select(getCommissionTypes)]).pipe(
        map(([arltt, commissionTypes]) => [
            { optionLabel: 'Alle', id: null, type: templateTypes.all },
            { optionLabel: 'Keine', id: null, type: templateTypes.none },
            ...arltt.map((a) => ({ optionLabel: a.Name, id: a.Id, type: templateTypes.arlTemplateType })),
            ...commissionTypes.map((a) => ({ optionLabel: a.Name, id: a.Id, type: templateTypes.commissionType })),
        ]),
    );

    constructor(
        private appDialog: AppDialogService,
        private store: Store<State>,
        @Inject(MAT_DIALOG_DATA) public Data: NewOptionDialogData,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<NewBookingOptionComponent, NewBookingOptionComponentReturnType>,
        public PS: PermissionService,
        public LS: LoadingService,
        @Inject(DEFAULT_CURRENCY_CODE) private defaultCurrencyCode: string,
        private arlDataService: ArlDataService,
        private arlTemplateDataService: ArlTemplateDataService,
        arlTemplateTypeRes: ARLTemplateTypeResolver,
        materialDataService: MaterialDataService,
        private selectArlDialogService: SelectArlDialogService,
    ) {
        firstValueFrom(this.store.select(getARLTemplateTypesFetched)).then((fetched) => {
            if (!fetched) {
                arlTemplateTypeRes.resolve();
            }
        });
        this.Multiselect.next(!this.Data.ListView);
        this.subs.push(
            // this.BookingPositionTemplates$.subscribe(),
            this.store
                .select(getCommissionTypes)
                .pipe(filter(isNotNullOrUndefined))
                .subscribe((cts) => {
                    this.ArlTypeForm.setValue(
                        this.Data?.accountsReceivableLedgerTemplateFilter?.CommissionTypeId
                            ? {
                                  optionLabel: cts.find((ct) => ct.Id === this.Data.accountsReceivableLedgerTemplateFilter.CommissionTypeId).Name,
                                  id: cts.find((ct) => ct.Id === this.Data.accountsReceivableLedgerTemplateFilter.CommissionTypeId).Id,
                                  type: templateTypes.commissionType,
                              }
                            : { optionLabel: 'Alle', id: null, type: templateTypes.all },
                    );
                }),
            this.MultipleSave$.pipe(withLatestFrom(this.store.select(getQuantityTypes), this.store.select(getLedgerImports))).subscribe(([, qt, ledgerImports]) => {
                this.LS.startLoading('save-multiple-arls', { dialogMessage: 'Abrechnungspositionen werden hinzugefügt' });
                const defaultQuantityTypeId = qt?.find((q) => q.Name === QuantityTypeNames.Generel)?.Id;
                firstValueFrom(this.ArlTemplateTableComponent.someDetailRowDirty$)
                    .then((dirty) => {
                        if (dirty) {
                            firstValueFrom(
                                this.appDialog.OpenConfirmationDialog({
                                    heading: 'Änderungen vorher speichern?',
                                    paragraph: 'Es gibt noch ungespeicherte änderungen an den Vorlagen, möchten Sie diese Speichern?',
                                }),
                            ).then(([res]) => {
                                if (res) {
                                    return this.ArlTemplateTableComponent.Submit();
                                }
                            });
                        }
                    })
                    .then(() => {
                        if (this.Data.onlyReturnTemplateIds) {
                            this.LS.endLoading('save-multiple-arls');
                            this.dialogRef.close(this.SelectedTemplates);
                            return;
                        }
                        firstValueFrom(this.store.select(getAccountsReceivableLedgerTemplateDictionary)).then(async (arlTemplateDict) => {
                            const ids: AccountsReceivableLedgerEntity[] = [];
                            const ledgerImportId = this.Data.newOptionDefaultValues.LedgerImportId;
                            const documentType = this.Data.newOptionDefaultValues.LedgerImportId ? ledgerImports.find((l) => l.Id === this.Data.newOptionDefaultValues.LedgerImportId).DocumentType : null;
                            const customerId = this.Data.newOptionDefaultValues.CustomerId;
                            const commissionId = this.Data.newOptionDefaultValues.CommissionId;
                            const date = FrontendDate(new Date());
                            if (this.Data.newOptionDefaultValues.LedgerImportDocumentType === 'order' || this.Data.newOptionDefaultValues.LedgerImportDocumentType === 'deliveryNote') {
                                const responsearls = await this.arlTemplateDataService.addArlTemplatesforOrder(this.SelectedTemplates, ledgerImportId || null, customerId || null, commissionId || null, documentType || null);
                                ids.push(...responsearls);
                            } else {
                                for (const id of this.SelectedTemplates) {
                                    const v = arlTemplateDict[id];
                                    let baseCost = v.BaseCost;
                                    let costAmount = v.CostAmount;
                                    if (v) {
                                        const c = await getCostFromArlTemplate(v, this.store, materialDataService);
                                        if (isNotNullOrUndefined(c)) {
                                            baseCost = c;
                                            costAmount = c;
                                        }
                                    }
                                    let hideInGroupSummary: boolean | null = null;
                                    if (v.Type === AccountsReceivableLedgerTypeEnum.Text) {
                                        hideInGroupSummary = true;
                                    }

                                    const [parent] = await this.arlDataService.addArls([
                                        {
                                            quantity: v.Quantity || 0,
                                            tax: v.Tax || 0,
                                            currencyCode: v.CurrencyCode || this.defaultCurrencyCode,
                                            bookingText: v.BookingText,
                                            baseCost: baseCost || 0,
                                            baseCostGross: v.BaseCostGross,
                                            costAmount: costAmount,
                                            ledgerImportId,
                                            documentType,
                                            customerId,
                                            commissionId,
                                            information: v.Information,
                                            quantityTypeId: v.QuantityTypeId || defaultQuantityTypeId,
                                            multiplikator: v.Multiplier,
                                            customProperties: JSON.stringify({
                                                ...v.CustomProperties,
                                                rootTemplateId: v.Id,
                                            }),
                                            date,
                                            isVisible: true,
                                            longInformation: v.Longtext,
                                            showLongInformation: v.ShowLongtext,
                                            inheritFromChildren: v.InheritFromChildren,
                                            type: v.Type as any,
                                            resourceId: v.ResourceId,
                                            materialId: v.MaterialId,
                                            jobSpecificationId: v.JobSpecificationId,
                                            itemNumber: AccountsReceivableLedgerEntity.autogenerateItemNumber,
                                            hideInGroupSummary: hideInGroupSummary,
                                        },
                                    ]);
                                    ids.push(parent);
                                    if (v.ArlTemplateIds?.length) {
                                        const childArgs = v.ArlTemplateIds.map<Promise<AccountsReceivableLedgerPostType>>(async (tId) => {
                                            const t = arlTemplateDict[tId];
                                            let baseCost = t.BaseCost;
                                            let costAmount = t.CostAmount;
                                            let hideInGroupSummary: boolean | null = null;

                                            if (t.Type === AccountsReceivableLedgerTypeEnum.Text) {
                                                hideInGroupSummary = true;
                                            }

                                            const c = await getCostFromArlTemplate(t, this.store, materialDataService);
                                            if (isNotNullOrUndefined(c)) {
                                                baseCost = c;
                                                costAmount = c;
                                            }
                                            return {
                                                quantity: t.Quantity || 0,
                                                tax: t.Tax || DEFAULT_TAX,
                                                currencyCode: t.CurrencyCode || this.defaultCurrencyCode,
                                                bookingText: t.BookingText,
                                                baseCost: baseCost || 0,
                                                costAmount: costAmount,
                                                baseCostGross: t.BaseCostGross,
                                                ledgerImportId,
                                                documentType,
                                                customerId,
                                                commissionId,
                                                information: t.Information,
                                                quantityTypeId: t.QuantityTypeId || defaultQuantityTypeId,
                                                multiplikator: t.Multiplier,
                                                customProperties: JSON.stringify({
                                                    ...t.CustomProperties,
                                                    rootTemplateId: t.Id,
                                                }),
                                                date,
                                                isVisible: t.IsVisible,
                                                longInformation: t.Longtext,
                                                showLongInformation: t.ShowLongtext,
                                                parentId: parent.Id,
                                                type: t.Type as any,
                                                resourceId: t.ResourceId,
                                                materialId: t.MaterialId,
                                                jobSpecificationId: t.JobSpecificationId,
                                                itemNumber: AccountsReceivableLedgerEntity.autogenerateItemNumber,
                                                hideInGroupSummary: hideInGroupSummary,
                                            };
                                        });
                                        const args = await Promise.all(childArgs);
                                        const children = await this.arlDataService.addArls(args);
                                        await this.arlDataService.changeArls([
                                            {
                                                id: parent.Id,
                                                arlIds: children.map((c) => c.Id),
                                                multiplikator: parent.Multiplier,
                                            },
                                        ]);
                                    }
                                }
                            }
                            this.LS.endLoading('save-multiple-arls');
                            if (this.Data?.newOptionDefaultValues?.LedgerImportId && this.Data.addToLedgerImport) {
                                this.dialogRef.close(ids.filter(isNotNullOrUndefined));
                            } else {
                                this.dialogRef.close();
                            }
                        });
                    });
            }),
        );
    }

    CompareByIdAndType = (a: SelectSearchOption<{ id: number; type: templateTypes }>, b: SelectSearchOption<{ id: number; type: templateTypes }>) => a.id === b.id && a.type === b.type;
    OpenModifyTemplateDialog(id: number = null, IsLarge = false) {
        this.dialog.open(ModifyBookingOptionTemplateDialogComponent, {
            data: {
                BookingOptionTemplateId: id,
                IsLarge: IsLarge,
            } as ModifyBookingOptionTemplateDialogComponentData,
            maxWidth: '82rem',
            minWidth: '20rem',
            // width: '90vw',
            panelClass: 'custom-dialog-class-without-padding',
        });
    }

    OpenLedgerImportList() {
        this.dialog
            .open<SelectLedgerImportLargeDialogComponent, SelectLedgerImportLargeDialogDialogData, SelectLedgerImportLargeDialogDialogReturnData>(SelectLedgerImportLargeDialogComponent, {
                ...SelectLedgerImportLargeDialogComponent.DefaultConfig,
                data: {
                    defaultFilter: this.Data?.selectLedgerImportDefaultFilter ? this.Data.selectLedgerImportDefaultFilter : undefined,
                },
            })
            .afterClosed()
            .subscribe((selectedLiId) => {
                if (selectedLiId) {
                    this.selectArlDialogService
                        .open({
                            AllowQuantityManipulation: true,
                            AllowQuantityTypeManipulation: true,
                            AllowBezeichnungManipulation: true,
                            AllowPriceManipulation: true,
                            LiId: selectedLiId,
                            LedgerImportDocumentType: this.Data.newOptionDefaultValues.LedgerImportDocumentType,
                            showForceItemNumbers: true,
                            forceItemNumbersDefaultOn: true,
                            forceItemNumberOninLi: this.Data.newOptionDefaultValues.forceItemNumbersDefaultOn,
                            showFixPrices: !(this.Data.newOptionDefaultValues.LedgerImportDocumentType === 'order' || this.Data.newOptionDefaultValues.LedgerImportDocumentType === 'deliveryNote'),
                        }).then(dialogRef => {
                            dialogRef.afterClosed()
                                .subscribe(async (arlIds) => {
                                    //  console.log(arlIds)
                                    // console.log(uniqArray(arlIds))

                                    if (arlIds?.ArlOutput.length > 0) {
                                        this.LS.startLoading('save-multiple-arls-from-li', { dialogMessage: 'Abrechnungspositionen werden hinzugefügt' });
                                        const ledgerImports = await firstValueFrom(this.store.select(getLedgerImportDictionary));
                                        const ledgerImportId = this.Data.newOptionDefaultValues.LedgerImportId;
                                        const documentType = this.Data.newOptionDefaultValues.LedgerImportId ? ledgerImports[this.Data.newOptionDefaultValues.LedgerImportId]?.DocumentType : null;
                                        const customerId = this.Data.newOptionDefaultValues.CustomerId;
                                        const commissionId = this.Data.newOptionDefaultValues.CommissionId;
                                        let newArls: AccountsReceivableLedgerEntity[];
                                        const arlDict = await firstValueFrom(this.arlDataService.selectAllArlsDict());

                                        let removedArls: ArlOutput[] = [];
                                        let result: DuplicatePositionsDialogResult | undefined;

                                        if (this.Data.newOptionDefaultValues.LedgerImportDocumentType === 'order' || this.Data.newOptionDefaultValues.LedgerImportDocumentType === 'deliveryNote') {

                                            newArls = await this.arlDataService.duplicateArlsWithoutChilds(
                                                arlIds.ArlOutput.map((v) => ({
                                                    ...v,
                                                    BaseCostAllowances: [],
                                                    ItemNumber: AccountsReceivableLedgerEntity.autogenerateItemNumber,
                                                    // todo ggf hier auch preise einfrieren ?
                                                    // setPriceFrozen: arlIds.fixPrices,
                                                    // getARLCalculationPreChargeByTypes: () => ledgerImports[arlDict[v.Id].LedgerImportId].ARLCalculationPreChargeByType || [],
                                                })),
                                                arlDict,
                                                ledgerImportId || null,
                                                customerId || null,
                                                commissionId || null,
                                                documentType || null,
                                                true
                                            );
                                        } else {
                                            if (arlIds.forceItemNumbers && ledgerImportId) {

                                                removedArls = arlIds.ArlOutput.filter(arl =>
                                                    this.Data.ledgerImportCurrentItemNumber.some(
                                                        ([itemNumber]) => itemNumber === arl.ItemNumber
                                                    )
                                                );

                                                if (removedArls.length > 0) {
                                                    const existing: ItemNumberInformation[] =
                                                        this.Data.ledgerImportCurrentItemNumber.filter(([itemNumber]) =>
                                                            removedArls.some(arl => arl.ItemNumber === itemNumber)
                                                        );

                                                    this.LS.endLoading('save-multiple-arls-from-li');

                                                    const dialogRef = this.dialog.open<DuplicatePositionsDialogComponent, DuplicatePositionsDialogData, DuplicatePositionsDialogResult>(DuplicatePositionsDialogComponent, {
                                                        minWidth: '80%',
                                                        data: {
                                                            selected: removedArls,
                                                            existing,
                                                            disableOkButton:  arlIds.ArlOutput.length === removedArls.length
                                                        } as DuplicatePositionsDialogData,
                                                    });

                                                    result = await firstValueFrom(dialogRef.afterClosed());


                                                    // Abbrechen / Dialog ohne Ergebnis
                                                    if (!result) {
                                                        this.dialogRef.close();
                                                        return;
                                                    }

                                                    if (result.action === 'ok') {
                                                        arlIds.ArlOutput = arlIds.ArlOutput.filter(
                                                            arl =>
                                                                !this.Data.ledgerImportCurrentItemNumber.some(
                                                                    ([itemNumber]) => itemNumber === arl.ItemNumber
                                                                )
                                                        );
                                                        arlIds.forceItemNumbers = true; // wofür? kann doch nur true sein
                                                    }


                                                    // if (result.action === 'force') {
                                                    //     arlIds.forceItemNumbers = false;
                                                    // }
                                                }
                                            }

                                            newArls = await this.arlDataService.duplicateArlsFromState(
                                                arlIds.ArlOutput.map((v) => ({
                                                    ...v,
                                                    BaseCostAllowances: arlDict[v.Id].InheritFromChildren ? arlDict[v.Id].BaseCostAllowances : arlDict[v.Id].BaseCostAllowances.filter(b => !!b.arlType),
                                                    ItemNumber: arlIds.forceItemNumbers ? arlDict[v.Id]?.ItemNumber : AccountsReceivableLedgerEntity.autogenerateItemNumber,
                                                    setPriceFrozen: arlIds.fixPrices,
                                                    getARLCalculationPreChargeByTypes: () => ledgerImports[arlDict[v.Id].LedgerImportId].ARLCalculationPreChargeByType || [],
                                                })),
                                                arlDict,
                                                ledgerImportId || null,
                                                customerId || null,
                                                commissionId || null,
                                                documentType || null,
                                                true
                                            );


                                        }
                                        this.LS.endLoading('save-multiple-arls-from-li');
                                        console.log({ newArls });
                                        if (this.Data?.newOptionDefaultValues?.LedgerImportId && this.Data.addToLedgerImport) {
                                            const rootArls = newArls.filter((arl) => !arl.ParentId);
                                            this.dialogRef.close({
                                                arls: rootArls,
                                                openSortDialog: (this.Data.newOptionDefaultValues?.forceItemNumberOninLi || removedArls.length !== 0) && result?.action !== 'ok',
                                                openSortDialogDefaultItemNumber: result?.action === 'force' && rootArls.length === 1 && !AccountsReceivableLedgerEntity.autogenerateItemNumbers.includes(rootArls[0].ItemNumber) ? rootArls[0].ItemNumber : null,
                                            });
                                        } else {
                                            this.dialogRef.close();
                                        }
                                    }
                                });
                    })

                }
            });
    }

    ngOnDestroy() {
        this.subs.forEach((s) => s.unsubscribe());
    }

    getTooltip(selectedRowIndex = this.SelectedRowIndex): string {
        if (this.Data.addedTemplateIds?.includes(selectedRowIndex)) {
            return 'Bereits Hinzugefügt';
        } else {
            return null;
        }
    }
}
